import pse from './img-pse.png';
import i472 from './img-472.png';
import sp from './img-sp.png';
import cs from './img-cs.png';
import sc from './img-sc.png';
import mr from './img-mr.png';
import jer from './img-jer.png';
import pr from './img-pr.png';
import pp from './img-pp.png';
import coop from './img-coop.png';
import fc from './img-fc.png';

import ef from './img-ef.png';
import kus from './img-kus.png';

import ea from './img-ea.png';
import bccc from './img-bccc.png';
import visa from './img-visa.png';
import ca from './img-ca.png';
import aws from './img-aws.png';
import mati from './img-mati.png';
import eth from './img-eth.png';

import amazon from './img_amazon.png'
import polo from './img_polo.png'
import nike from './img_nike.png'
import sephora from './img_sephora.png'

export let logosBank = [pse, i472, sp, cs, sc, mr, jer, pr, pp, coop, fc]

export let logosMonetta = [ef, kus, pse]

export let partners = [bccc, visa, ca, aws, mati, ea, eth, kus]

export let newMonettas = [ef, i472, sp, cs, sc, mr, jer, pr, pp, coop, fc ]

export let newCop = [bccc]

export let homeMonetta = [eth]
export let homeCard = [bccc, visa]
export let homeShopper = [amazon, nike, polo, sephora]